import React, { useEffect, useRef } from "react";
import "./movieCard/MovieCss.css";
import FetchTrending, {
  FetchTopRated,
  FetchUpcoming,
  FetchPopular,
} from "./DataFetching";
import MovieCard from "./movieCard/MovieCard";
import { Box, Typography } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function Movies() {
  const trending = FetchTrending();
  const topRated = FetchTopRated();
  const upcomming = FetchUpcoming();
  const popular = FetchPopular();

  /* CREATE AN ARROW FUNCTION TO MAP THE MOVIE DETAILS AND STORE IT IN A VARIABLE */
  const readTrending = () => {
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 16
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
      }
    };
    const Trend = trending.map((movie) => {
      /* MOVIE DETAILS */
      const movieTitle = movie.movieTitle;
      const movieId = movie.movieId;
      const movieOverview = movie.movieOverview;
      const backgroundImg = movie.backgroundImg;
      const posterImg = movie.posterImg;
      const releaseDate = movie.releaseDate;

      /* EDIT THIS... DITO MAG GAGAWA NG HTML CODE SA RETURN NITO..
       SAKA TATAWAGIN NAMAN SA RETURN SA PINAKA BABA */
      return (
        <>
          <MovieCard
            movieTitle={movieTitle}
            movieId={movieId}
            movieOverview={movieOverview}
            backgroundImg={backgroundImg}
            posterImg={posterImg}
            releaseDate={releaseDate}
          />
        </>
      );
    });
    return (
      <Carousel 
        responsive={responsive}
        swipeable={true}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        transitionDuration={300}
        draggable={false}
        focusOnSelect={true}
        centerMode={true}
        slidesToSlide={3}
      > 
        {Trend}
      </Carousel>
    );
  };
  
  const readTopRated = () => {
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 16
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
      }
    };
    const Top = topRated.map((movie) => {
      /* MOVIE DETAILS */
      const movieTitle = movie.movieTitle;
      const movieId = movie.movieId;
      const movieOverview = movie.movieOverview;
      const backgroundImg = movie.backgroundImg;
      const posterImg = movie.posterImg;
      const releaseDate = movie.releaseDate;

      /* EDIT THIS... DITO MAG GAGAWA NG HTML CODE SA RETURN NITO..
          SAKA TATAWAGIN NAMAN SA RETURN SA PINAKA BABA */
      return (
        <>
          <MovieCard
            movieTitle={movieTitle}
            movieId={movieId}
            movieOverview={movieOverview}
            backgroundImg={backgroundImg}
            posterImg={posterImg}
            releaseDate={releaseDate}
          />
        </>
      );
    });
    return (
      <Carousel 
        responsive={responsive}
        swipeable={true}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        transitionDuration={300}
        draggable={false}
        focusOnSelect={true}
        centerMode={true}
        slidesToSlide={3}
      > 
        {Top}
      </Carousel>
    );
  };

  const readUpcomming = () => {
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 16
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
      }
    };
    const Up = upcomming.map((movie) => {
      /* MOVIE DETAILS */
      const movieTitle = movie.movieTitle;
      const movieId = movie.movieId;
      const movieOverview = movie.movieOverview;
      const backgroundImg = movie.backgroundImg;
      const posterImg = movie.posterImg;
      const releaseDate = movie.releaseDate;

      /* EDIT THIS... DITO MAG GAGAWA NG HTML CODE SA RETURN NITO..
          SAKA TATAWAGIN NAMAN SA RETURN SA PINAKA BABA */
      return (
        <>
          <MovieCard
            movieTitle={movieTitle}
            movieId={movieId}
            movieOverview={movieOverview}
            backgroundImg={backgroundImg}
            posterImg={posterImg}
            releaseDate={releaseDate}
          />
        </>
      );
    });
    return (
      <Carousel 
        responsive={responsive}
        swipeable={true}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        transitionDuration={300}
        draggable={false}
        focusOnSelect={true}
        centerMode={true}
        slidesToSlide={3}
        >
        {Up}
      </Carousel>
    );
  };

  const readPopular = () => {
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 16
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 6
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2
      }
    };
    const Pop = popular.map((movie) => {
      /* MOVIE DETAILS */
      const movieTitle = movie.movieTitle;
      const movieId = movie.movieId;
      const movieOverview = movie.movieOverview;
      const backgroundImg = movie.backgroundImg;
      const posterImg = movie.posterImg;
      const releaseDate = movie.releaseDate;

      /* EDIT THIS... DITO MAG GAGAWA NG HTML CODE SA RETURN NITO..
          SAKA TATAWAGIN NAMAN SA RETURN SA PINAKA BABA */
      return (
        <>
          <MovieCard
            movieTitle={movieTitle}
            movieId={movieId}
            movieOverview={movieOverview}
            backgroundImg={backgroundImg}
            posterImg={posterImg}
            releaseDate={releaseDate}
          />
        </>
      );
    });
    return (
      <Carousel 
        responsive={responsive}
        swipeable={true}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        transitionDuration={300}
        draggable={false}
        focusOnSelect={true}
        centerMode={true}
        slidesToSlide={3}
        >
        {Pop}
      </Carousel>
    );
  };


  
  const mainContainerRef = useRef(null);

  useEffect(() => {
    const mainContainer = mainContainerRef.current;
    mainContainer.addEventListener('wheel', handleScroll);

    return () => {
      mainContainer.removeEventListener('wheel', handleScroll);
    };
  }, []);

  const handleScroll = (event) => {
    event.preventDefault();
    const scrollAmount = event.deltaY;
    const newScrollTop = mainContainerRef.current.scrollTop + scrollAmount;
    mainContainerRef.current.scrollTop = newScrollTop;
  };



  return (
    <Box className= 'MoviePage'>
     <Box id='movieMainContainer' ref={mainContainerRef}>
      <Typography variant= "h4" className="movieCat" sx={{marginTop: '20px' , marginLeft: '20px', marginBottom: '10px'}}>Trending Movies</Typography>
      <Box sx={{marginBottom: '20px' , marginTop: '0px'}}>{readTrending()}</Box>
      <Typography variant= "h4" className="movieCat" sx={{marginLeft: '20px', marginBottom: '10px'}}>Top Rated Movies</Typography>
      <Box sx={{marginBottom: '20px', marginTop: '0px'}}>{readTopRated()}</Box>
      <Typography variant= "h4" className="movieCat" sx={{marginLeft: '20px', marginBottom: '10px'}}>Upcoming Movies</Typography>
      <Box sx={{marginBottom: '20px' , marginTop: '10px'}}>{readUpcomming()}</Box>
      <Typography variant= "h4" className="movieCat" sx={{marginTop: '10px', marginLeft: '20px', marginBottom: '10px' }}>Popular Movies</Typography>
      <Box sx={{marginBottom: '100px', marginTop: '10px'}}>{readPopular()}</Box>

     </Box>
    </Box>
  );
}

export default Movies;